<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ $t('agenda.confirmar-atendimento') }}</h3>
      </template>
      <template #body>
        <div class="has-text-centered">
          <p>{{ mensagemOrientacao }}</p>
        </div>
        <div
          class="exam-preparation"
          v-if="dadosExames != null && dadosExames.Recomendacoes != null"
        >
          <h1 class="exam-subtitle">
            {{ $t('exames.titulo') }}
          </h1>
          <ul class="exam-item">
            <li
              v-for="exame in dadosExames.Recomendacoes.Exames"
              :key="exame.index"
            >
              {{ exame.Descricao }}
            </li>
          </ul>
          <h2 class="exam-subtitle">
            {{ $t('labels.recomendacoes') }}
          </h2>
          <ul class="exam-item">
            <li
              v-for="informacao in dadosExames.Recomendacoes.InformacoesGerais"
              :key="informacao"
            >
              {{ informacao }}
            </li>
          </ul>
        </div>
      </template>
      <template #footer>
        <div class="columns absence">
          <b-button
            class="column button button-secondary"
            :loading="loading"
            @click="confirmarAtendimento()"
          >
            {{ $t('botoes.sim') }}
          </b-button>
          &nbsp;
          <b-button
            v-if="!loading"
            class="column cancel"
            @click="
              podeRemarcarAtendimentos
                ? redirectToJustificarAusencia()
                : redirectToChat()
            "
          >
            {{ $t('agenda.ausencia') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from './ModalTemplate'
import AgendamentoService from '@/services/agendamento-service'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmarAtendimentoModal',
  components: { ModalTemplate },
  data() {
    return {
      mensagemOrientacao: this.$props.mensagem,
      loading: false
    }
  },
  props: {
    toggle: {
      type: Boolean,
      default: false
    },
    atendimentos: {
      type: Array,
      default: null
    },
    mensagem: {
      type: String,
      default: ''
    },
    dadosExames: {
      type: Object,
      default: null
    },
    podeRemarcarAtendimentos: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      paciente: 'dadosPaciente'
    })
  },
  methods: {
    toggleInfoModal() {
      this.$emit('closeModal', 'cancelar')
    },
    confirmarAtendimento() {
      this.loading = true
      if (
        Array.isArray(this.$props.atendimentos) &&
        this.$props.atendimentos.length > 1
      ) {
        AgendamentoService.postConfirmarVariosAtendimentos(
          this.$props.atendimentos
        )
          .then((response) => {
            if (response.status === 200) {
              this.$emit('closeModal', 'confirmado')
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        AgendamentoService.postConfirmarAtendimento(this.$props.atendimentos[0])
          .then((response) => {
            if (response.status === 200) {
              this.$emit('closeModal', 'confirmado')
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    redirectToJustificarAusencia() {
      this.$emit('closeModal', 'justificarAusencia')
    },
    redirectToChat() {
      this.$emit('closeModal', 'chat')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';

.absence {
  margin-bottom: 4px;
  margin: 0 auto;
  width: 90%;
  .confirm {
    margin: auto;
    box-sizing: border-box;
    height: 2.5rem;
    width: 12.5rem;

    color: var(--light-blue);
    border: 0.0625rem solid $light-blue;
    border-color: var(--light-blue);
    border-radius: 0.25rem;
    &:hover {
      color: var(--neutral-color-5);

      background-color: var(--light-blue);
      transition: all 0.2s;
    }
  }

  .cancel {
    color: var(--orange-dark);
    font-weight: 500;
    font-size: 0.875rem;
    height: 2.25rem;
    border: 1px solid $orange-dark-light;
  }

  @media screen and (max-width: 768px) {
    .cancel {
      margin-top: 1rem;
    }
  }
}

.exam-preparation {
  .exam-subtitle {
    font-weight: $font-bold;
  }
  .exam-item {
    margin-bottom: 0.25rem;
  }
  ul {
    list-style: inside;
  }
}
</style>
